"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _AssociatedOpenObjectsStore = _interopRequireDefault(require("crm_ui/engagementAssociations/AssociatedOpenObjectsStore"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _LoadingStatus2 = require("crm_data/flux/LoadingStatus");

var _pluck = _interopRequireDefault(require("transmute/pluck"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _AssociationsStore = _interopRequireDefault(require("crm_data/associations/AssociationsStore"));

var _NeverLogStore = _interopRequireDefault(require("customer-data-communicator/data/validation/NeverLogStore"));

var _EmailValidation = require("customer-data-email/schema/validation/EmailValidation");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _CommunicatorStore = _interopRequireDefault(require("customer-data-communicator/data/communicator/stores/CommunicatorStore"));

function getDealsToAssociate(objectTypeContext, subjectIdContext) {
  if (objectTypeContext === _ObjectTypes.TICKET) {
    return (0, _immutable.Set)();
  }

  if (objectTypeContext === _ObjectTypes.DEAL) {
    return (0, _immutable.Set)([subjectIdContext]);
  }

  var openDeals = _AssociatedOpenObjectsStore.default.get((0, _immutable.Map)({
    objectType: objectTypeContext,
    subjectId: "" + subjectIdContext,
    objectTypeToFetch: _ObjectTypes.DEAL
  }));

  if ((0, _LoadingStatus2.isLoading)(openDeals)) {
    return _LoadingStatus.LOADING;
  }

  return (0, _pluck.default)('objectId', openDeals).toSet();
}

function getTicketsToAssociate(objectTypeContext, subjectIdContext) {
  if (objectTypeContext === _ObjectTypes.TICKET) {
    return (0, _immutable.Set)([subjectIdContext]);
  }

  return (0, _immutable.Set)();
}

function getCompaniesToAssociate(objectType, subjectId, objectTypeContext, subjectIdContext) {
  var companyIdsToAssociate = (0, _immutable.Set)();
  var companiesAssociatedWithSubject = null;
  var companiesAssociatedWithContext = null;

  if (objectType === _ObjectTypes.COMPANY) {
    companyIdsToAssociate = companyIdsToAssociate.add(subjectId);
  } else {
    companiesAssociatedWithSubject = _AssociationsStore.default.get({
      objectType: objectType,
      objectId: "" + subjectId,
      associationType: objectType + "_TO_" + _ObjectTypes.COMPANY
    });
  }

  if (objectTypeContext === _ObjectTypes.COMPANY) {
    companyIdsToAssociate = companyIdsToAssociate.add(subjectIdContext);
  } else {
    companiesAssociatedWithContext = _AssociationsStore.default.get({
      objectType: objectTypeContext,
      objectId: "" + subjectIdContext,
      associationType: objectTypeContext + "_TO_" + _ObjectTypes.COMPANY
    });
  }

  if ((0, _LoadingStatus2.isLoading)(companiesAssociatedWithSubject, companiesAssociatedWithContext)) {
    return _LoadingStatus.LOADING;
  }

  if (companiesAssociatedWithSubject) {
    companyIdsToAssociate = companyIdsToAssociate.union(companiesAssociatedWithSubject.get('results'));
  }

  if (companiesAssociatedWithContext) {
    companyIdsToAssociate = companyIdsToAssociate.union(companiesAssociatedWithContext.get('results'));
  }

  return companyIdsToAssociate;
}

function getContactsToAssociate(objectType, subjectId, objectTypeContext, subjectIdContext) {
  var contactIdsToAssociate = (0, _immutable.Set)();

  if (objectType === _ObjectTypes.CONTACT) {
    contactIdsToAssociate = contactIdsToAssociate.add(subjectId);
  }

  if (objectTypeContext === _ObjectTypes.CONTACT) {
    contactIdsToAssociate = contactIdsToAssociate.add(subjectIdContext);
  }

  return contactIdsToAssociate;
}

var DefaultAssociationsDependency = {
  propTypes: {
    objectType: _ProfileObjectTypesType.default.isRequired,
    subjectId: _propTypes.default.string.isRequired,
    subject: _propTypes.default.object,
    engagementType: _propTypes.default.string.isRequired
  },
  stores: [_AssociatedOpenObjectsStore.default, _AssociationsStore.default, _NeverLogStore.default, _CommunicatorStore.default],
  deref: function deref(props) {
    var objectType = props.objectType,
        subjectId = props.subjectId,
        subject = props.subject;
    var defaultAssociations = (0, _immutable.Map)({
      ownerIds: (0, _immutable.Set)(),
      companyIds: (0, _immutable.Set)(),
      contactIds: (0, _immutable.Set)(),
      dealIds: (0, _immutable.Set)(),
      ticketIds: (0, _immutable.Set)()
    });

    var objectTypeContext = _CommunicatorStore.default.get('objectTypeContext');

    var subjectIdContext = _CommunicatorStore.default.get('subjectIdContext');

    if (!objectTypeContext || !subjectIdContext) {
      return _LoadingStatus.LOADING;
    }

    var contactsToAssociate = getContactsToAssociate(objectType, Number(subjectId), objectTypeContext, Number(subjectIdContext));
    var companiesToAssociate = getCompaniesToAssociate(objectType, Number(subjectId), objectTypeContext, Number(subjectIdContext));
    var dealsToAssociate = getDealsToAssociate(objectTypeContext, Number(subjectIdContext));
    var ticketsToAssociate = getTicketsToAssociate(objectTypeContext, Number(subjectIdContext));

    if ((0, _LoadingStatus2.isLoading)(companiesToAssociate, dealsToAssociate, ticketsToAssociate)) {
      return _LoadingStatus.LOADING;
    } // dont associate contact if contact email is in neverlog list


    if (props.engagementType === _EngagementTypes.EMAIL) {
      var neverLogList = _NeverLogStore.default.get('neverlogList');

      if ((0, _LoadingStatus2.isLoading)(neverLogList) || (0, _LoadingStatus2.isLoading)(subject)) {
        return _LoadingStatus.LOADING;
      }

      var emailAddress = (0, _ImmutableModel.getProperty)(subject, 'email');

      if (emailAddress && (0, _EmailValidation.isEmailInNeverLogList)(neverLogList, emailAddress)) {
        contactsToAssociate = (0, _immutable.Set)();
      }
    }

    return defaultAssociations.merge((0, _immutable.Map)({
      contactIds: contactsToAssociate,
      companyIds: companiesToAssociate,
      dealIds: dealsToAssociate,
      ticketIds: ticketsToAssociate
    }));
  }
};
var _default = DefaultAssociationsDependency;
exports.default = _default;
module.exports = exports.default;